module.exports = __webpack_public_path__ + "img/icons BFr_9.5f692e69.png";